<template>
<div class="featured-dorms section">
    <div class="vld-parent mycenter">
      <loading :active.sync="isLoading" 
      :is-full-page="fullPage"></loading>
    </div> 
  <container>
    <div class="section__header mycenter">
      <div class="section__title">
        <span class="color-pink">Most Popular</span> Movies
      </div>
      <div class="section__right">
        <!--<div v-for="(city,index) in cities" :key="city.id">-->
          <!--<SubpageCategory :links="city" @click.native="handleClickNavItem(index)" :class="{active : index===currentNav}" class="DesktopTab"/>-->
        <!--</div>-->
<!--         <div class="subpage-nav__list DesktopTab">
          <div class="subpage-nav__item" v-if="currentNav !== null">
            <button class="subpage-nav__link" @click="clearFilter">
              <span class="button__wrp">
                <span class="btn-txt">
                  See All
                </span>
              </span>
            </button>
          </div>
        </div> -->

        <div class="mobileTab">
          <select-box :options="cities" title="Select Genre"/>
        </div>

        <!--<div class="mobileTab">-->
          <!--<select-box :options="linkMobile" title="İl Seçiniz"/>-->
        <!--</div>-->
      </div>
    </div>
      <ContentLoader v-if="!dorms && !mobileCheck"
      :height="900">
        <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="103" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="203" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="305" y="0" rx="3" ry="3" width="94" height="110" />
        
        <rect x="3" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="103" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="203" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="305" y="115" rx="3" ry="3" width="94" height="110" />        
      </ContentLoader>
      <ContentLoader v-if="!dorms && mobileCheck">
        <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />      
      </ContentLoader>      
    <div class="featured-dorms__cnt">
      <div class="featured-dorms__list dorm-card__list">
        <swiper :options="swiperOption" style="display: none">
          <swiper-slide
            v-for="dorm in dorms"
            :key="dorm.id"
            class="featured-dorms__col col-xl-3 col-lg-3 col-md-4">
            <dorm-card
              :dorm="dorm"
            />
          </swiper-slide>
          <div class="swiper-paginations" style="text-align: center;" slot="pagination"></div>
        </swiper>
        <div
          v-for="dorm in dorms"
          :key="dorm.id"
          class="featured-dorms__col desktop-dorm col-xl-3 col-lg-3 col-md-4">
          <movie-card
            :movie="dorm"
          />
        </div>
        <empty-content :content="emptyContent" v-if="dorms && dorms.length === 0"/>
      </div>


    </div>

  </container>
</div>
</template>

<script>
import MovieCard from '@/components/MovieCard'
import SubpageCategory from '@/components/SubpageCategory'
import SelectBox from '@/components/SelectBox'
import EmptyContent from '@/components/EmptyContent'
import { ContentLoader } from 'vue-content-loader'
import axios from 'axios'

export default {
  name: 'FeaturedDormsNoTabs',
  components: {
    EmptyContent,
    MovieCard,
    SelectBox,
    ContentLoader
  },
  data () {
    return {
      isLoading: false,
      fullPage: true,       
      currentNav: null,
      dorms: null,
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 20,
        slidesPerGroup: 2,
        breakpoints: {
          640: {
            slidesPerView: 'auto',
            centeredSlides: 'center',
            slidesPerGroup: 1
          },
          320: {
            slidesPerView: 'auto',
            centeredSlides: false,
            slidesPerGroup: 1

          }
        },
        pagination: {
          el: '.swiper-paginations',
          clickable: true
        }
      },
      cities: [],
      emptyContent: {
        icon: 'icon-search',
        title: 'No Result!',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      },
      mainDorms: []
    }
  },
  methods: {
    getDorms () {
      let self = this
      this.isLoading = true
      axios.get('/3/movie/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&page=1')
        .then(response => {
          this.isLoading = false
          self.dorms = response.data.results
          self.mainDorms = response.data.dorms
          self.cities = response.data.cities
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
  },
  created () {
     this.getDorms()
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/components/featured-dorms";

.mycenter {
 display:table;
 margin:0 auto;
}
</style>
